import { render } from "./InactiveScreen.vue?vue&type=template&id=81f2d9b6"
import script from "./InactiveScreen.vue?vue&type=script&lang=js"
export * from "./InactiveScreen.vue?vue&type=script&lang=js"

import "./InactiveScreen.vue?vue&type=style&index=0&id=81f2d9b6&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__